import {
  ComponentStyleConfig,
  StyleFunctionProps,
  Tooltip,
} from '@chakra-ui/react';

export const components: Record<string, ComponentStyleConfig> = {
  DataList: {
    baseStyle: ({ colorMode }: { colorMode: 'light' | 'dark' }) => ({
      header: {
        bg: colorMode === 'dark' ? 'gray.800' : 'gray.50',
      },
      divider: {
        opacity: 1,
        borderColor: 'border.layer.2',
      },
    }),
  },
  Radio: {
    baseStyle: {
      label: {
        textTransform: 'none',
      },
    },
  },
  Modal: {
    sizes: {
      xl: {
        dialog: {
          minWidth: '800px',
          maxWidth: '100vw',
        },
      },
    },
  },
  InfoHeaders: {
    baseStyle: ({ colorMode }) => {
      return {
        color: colorMode === 'dark' ? 'gray.200' : 'gray.400',
      };
    },
  },
  SeverityBox: {
    baseStyle: ({
      colorMode,
      colorScheme,
      isSelected,
      isActive,
    }: StyleFunctionProps) => {
      return {
        border: 'solid .1em',
        borderRadius: 'base',
        bg: colorMode === 'dark' ? `${colorScheme}.600` : `${colorScheme}.200`,
        borderColor: `${colorScheme}.400`,
        color: colorMode === 'dark' ? `white` : `black`,
        ...(isSelected
          ? { outline: 'solid 1px', outlineColor: 'blue.600' }
          : {}),
        ...(isActive ? { opacity: 0.5, cursor: 'not-allowed' } : {}),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
        h: 'fit-content',
        position: 'relative',
        whiteSpace: 'nowrap',
      };
    },
    sizes: {
      xl: {
        h: 10,
        w: 10,
        fontSize: 'h4',
        lineHeight: 1,
      },
      lg: {
        h: 7,
        w: 7,
        fontSize: 'lg',
        lineHeight: 1,
      },
      sm: {
        h: 6,
        w: 10,
        fontSize: 'sm',
        lineHeight: 1,
      },
    },
    defaultProps: {
      size: 'lg',
    },
  },
};

Tooltip.defaultProps = {
  hasArrow: true,
};
